import React, { useState, useContext } from "react";
import {
  Popover,
  Chip,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Box,
} from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import { SearchContext } from "./SearchContainer";

import useStyles from "./styles";
import { VideoRegion } from "@booyaltd/core";

const RegionFilter = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const { search, updateSearch } = useContext(SearchContext);

  const handleFilterOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "region-popover" : undefined;

  const handleFilterChange = (e: any, value: "all" | VideoRegion) => {
    updateSearch({
      region: value === "all" ? undefined : value,
    });
  };

  return (
    <>
      <Chip
        className={classes.filterChip}
        label={
          <>
            <Box display="flex" alignItems="center">
              <LanguageIcon
                className={
                  search && search.region
                    ? classes.filterChipIconActive
                    : classes.filterChipIcon
                }
              />
              <Typography className={classes.filterChipLabel}>
                {!search || !search.region || search.region.toString() === "all"
                  ? "Region"
                  : search.region?.toUpperCase()}
              </Typography>
            </Box>
          </>
        }
        aria-describedby={id}
        onClick={handleFilterOpen}
      />

      <Popover
        classes={{ paper: classes.popOverContainer }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleFilterClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <RadioGroup
          aria-label="region_filter"
          name="regionFilter"
          value={search?.region || "all"}
          // @ts-ignore
          onChange={handleFilterChange}
        >
          {/* Get Regions Here  */}
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value="all"
            control={<Radio color="primary" />}
            label="All"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.NI}
            control={<Radio color="primary" />}
            label="NI"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.ROI}
            control={<Radio color="primary" />}
            label="ROI"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.GB}
            control={<Radio color="primary" />}
            label="GB"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.USA}
            control={<Radio color="primary" />}
            label="USA"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.EU}
            control={<Radio color="primary" />}
            label="EU"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.NZ}
            control={<Radio color="primary" />}
            label="NZ"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.AU}
            control={<Radio color="primary" />}
            label="AU"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.CA}
            control={<Radio color="primary" />}
            label="CA"
          />
          <FormControlLabel
            classes={{ label: classes.filterLabel }}
            value={VideoRegion.FR}
            control={<Radio color="primary" />}
            label="FR"
          />
        </RadioGroup>
      </Popover>
    </>
  );
};

export default RegionFilter;
